import React from "react";
import Loading from "../../components/common/loading";
import axios from "axios";
import NotificationManager from "../../utils/notificationManager";

const styles = {
  pageWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  headerCard: {
    background: "transparent",
    borderRadius: 0,
    border: "none",
    boxShadow: "none",
    padding: 0,
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  headerLead: {
    display: "flex",
    alignItems: "flex-start",
    flexWrap: "wrap",
    gap: "16px",
    justifyContent: "space-between",
  },
  titleBlock: {
    display: "flex",
    flex: "1 1 360px",
    flexDirection: "column",
    gap: "6px",
  },
  title: {
    margin: 0,
    fontSize: "22px",
    fontWeight: 600,
    color: "#1f2d3d",
  },
  subtitle: {
    margin: 0,
    color: "#607284",
    fontSize: "14px",
    lineHeight: 1.7,
  },
  headerMetaRow: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "12px",
  },
  metaItem: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    padding: "12px 14px",
    borderRadius: 4,
    border: "1px solid #e2e8f0",
    background: "#f8fafc",
  },
  metaLabel: {
    fontSize: "12px",
    letterSpacing: "0.02em",
    textTransform: "uppercase",
    color: "#64748b",
  },
  metaValue: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#1f2d3d",
  },
  headerNote: {
    margin: 0,
    color: "#6b7a8c",
    fontSize: "13px",
    lineHeight: 1.6,
  },
  headerActions: {
    display: "flex",
    flex: "0 0 auto",
    justifyContent: "flex-end",
    gap: "12px",
    flexWrap: "wrap",
  },
  actionButton: {
    minWidth: "110px",
    padding: "10px 16px",
    borderRadius: "5px",
    border: "none",
    fontWeight: 600,
    fontSize: "14px",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  secondaryButton: {
    background: "#ffffff",
    border: "1px solid #cbd5f5",
    color: "#1f2d3d",
  },
  primaryButton: {
    background: "var(--highlight-color)",
    border: "1px solid var(--highlight-color)",
    color: "var(--highlight-font-color)",
  },
  disabledButton: {
    opacity: 0.5,
    cursor: "not-allowed",
    boxShadow: "none",
  },
  sectionGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
    gap: "24px",
  },
  sectionCard: {
    background: "#ffffff",
    borderRadius: 4,
    border: "1px solid #e2e8f0",
    boxShadow: "0 1px 2px rgba(15,23,42,0.04)",
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  sectionHeading: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  sectionTitle: {
    margin: 0,
    fontSize: "20px",
    fontWeight: 600,
    color: "#1f2d3d",
  },
  sectionDescription: {
    margin: 0,
    color: "#64748b",
    fontSize: "14px",
    lineHeight: 1.6,
  },
  fieldStack: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  fieldLabel: {
    margin: 0,
    fontSize: "15px",
    fontWeight: 600,
    color: "#1f2d3d",
  },
  fieldHint: {
    margin: 0,
    color: "#64748b",
    fontSize: "13px",
    lineHeight: 1.6,
  },
  input: {
    width: "100%",
    padding: "11px 14px",
    borderRadius: "5px",
    border: "1px solid #cbd5f5",
    background: "#ffffff",
    fontSize: "14px",
    color: "#1f2d3d",
    outline: "none",
    boxShadow: "none",
    transition: "all 0.2s ease",
  },
  helperText: {
    margin: 0,
    color: "#94a3b8",
    fontSize: "12px",
    lineHeight: 1.5,
  },
  textarea: {
    minHeight: "180px",
    resize: "vertical",
    lineHeight: 1.55,
    whiteSpace: "pre-wrap",
  },
  toggleList: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  toggleButton: (enabled, accent) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px",
    borderRadius: "6px",
    padding: "12px 16px",
    border: `1px solid ${enabled ? accent : "#d8e1eb"}`,
    background: "#ffffff",
    boxShadow: enabled ? "0 1px 2px rgba(15,23,42,0.08)" : "none",
    cursor: "pointer",
    transition: "border-color 0.2s ease, box-shadow 0.2s ease",
    textAlign: "left",
  }),
  toggleButtonDisabled: {
    opacity: 0.58,
    cursor: "not-allowed",
  },
  toggleCopy: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  toggleLabel: {
    fontSize: "15px",
    fontWeight: 600,
    color: "#1f2d3d",
  },
  toggleDescription: {
    margin: 0,
    fontSize: "13px",
    color: "#475569",
    lineHeight: 1.6,
  },
  toggleSwitch: (enabled, accent) => ({
    position: "relative",
    minWidth: "44px",
    height: "24px",
    borderRadius: "999px",
    background: enabled ? accent : "#cbd5f5",
    transition: "background 0.2s ease",
  }),
  toggleKnob: (enabled) => ({
    position: "absolute",
    top: "3px",
    left: enabled ? "24px" : "4px",
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    background: "#ffffff",
    boxShadow: "0 1px 3px rgba(15,23,42,0.2)",
    transition: "left 0.2s ease",
  }),
  adminList: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  adminChip: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "10px 14px",
    borderRadius: "5px",
    border: "1px solid #e2e8f0",
    background: "#f8fafc",
    color: "#1f2d3d",
    fontSize: "13px",
    fontWeight: 500,
  },
  adminInitial: {
    width: "28px",
    height: "28px",
    borderRadius: "50%",
    background: "#e0e7ff",
    color: "#312e81",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 600,
    fontSize: "13px",
  },
  emptyState: {
    borderRadius: 10,
    border: "1px dashed #d8e1eb",
    background: "#f8fafc",
    padding: "14px 16px",
    color: "#64748b",
    fontSize: "13px",
  },
};

const darkOverrides = {
  headerCard: {
    background: "transparent",
    border: "none",
    boxShadow: "none",
    borderRadius: 0,
  },
  title: {
    color: "#f8fafc",
  },
  subtitle: {
    color: "#cbd5e1",
  },
  metaItem: {
    background: "rgba(148, 163, 184, 0.12)",
    border: "1px solid rgba(148, 163, 184, 0.25)",
  },
  metaLabel: {
    color: "#94a3b8",
  },
  metaValue: {
    color: "#f8fafc",
  },
  headerNote: {
    color: "#94a3b8",
  },
  secondaryButton: {
    background: "rgba(15, 23, 42, 0.65)",
    border: "1px solid rgba(148, 163, 184, 0.4)",
    color: "#f8fafc",
  },
  sectionCard: {
    background: "rgba(15, 23, 42, 0.7)",
    border: "1px solid rgba(148, 163, 184, 0.25)",
    boxShadow: "0 14px 30px rgba(15, 23, 42, 0.35)",
    borderRadius: 6,
  },
  sectionTitle: {
    color: "#f8fafc",
  },
  sectionDescription: {
    color: "#94a3b8",
  },
  fieldLabel: {
    color: "#f8fafc",
  },
  fieldHint: {
    color: "#94a3b8",
  },
  input: {
    border: "1px solid rgba(148, 163, 184, 0.4)",
    background: "rgba(15, 23, 42, 0.55)",
    color: "#f8fafc",
  },
  helperText: {
    color: "#94a3b8",
  },
  textarea: {
    minHeight: "180px",
  },
  toggleButton: (enabled, accent) => ({
    ...styles.toggleButton(enabled, accent),
    background: "rgba(15, 23, 42, 0.65)",
    border: "1px solid rgba(148, 163, 184, 0.25)",
    boxShadow: enabled
      ? `0 12px 24px ${accent}33`
      : "0 8px 18px rgba(15, 23, 42, 0.35)",
    color: "#f8fafc",
  }),
  toggleLabel: {
    color: "#f8fafc",
  },
  toggleDescription: {
    color: "#94a3b8",
  },
  toggleSwitch: (enabled, accent) => ({
    ...styles.toggleSwitch(enabled, accent),
    background: enabled ? accent : "rgba(148, 163, 184, 0.35)",
    boxShadow: "inset 0 0 0 1px rgba(15, 23, 42, 0.45)",
  }),
  toggleKnob: (enabled) => ({
    ...styles.toggleKnob(enabled),
    background: "#0f172a",
    boxShadow: "0 4px 8px rgba(15,23,42,0.45)",
  }),
  adminChip: {
    background: "rgba(148, 163, 184, 0.12)",
    border: "1px solid rgba(148, 163, 184, 0.25)",
    color: "#f8fafc",
  },
  adminInitial: {
    background: "rgba(129, 140, 248, 0.35)",
    color: "#e0e7ff",
  },
  emptyState: {
    border: "1px dashed rgba(148, 163, 184, 0.4)",
    background: "rgba(15, 23, 42, 0.55)",
    color: "#cbd5e1",
  },
};

const mergeStyles = (base, overrides) => {
  const merged = { ...base };
  Object.keys(overrides).forEach((key) => {
    const overrideValue = overrides[key];
    if (typeof overrideValue === "function") {
      merged[key] = overrideValue;
    } else if (
      overrideValue &&
      typeof overrideValue === "object" &&
      !Array.isArray(overrideValue)
    ) {
      merged[key] = { ...(base[key] || {}), ...overrideValue };
    } else {
      merged[key] = overrideValue;
    }
  });
  return merged;
};

const getStyles = (dark) => (dark ? mergeStyles(styles, darkOverrides) : styles);

export default class TeamSettings extends React.Component {
  state = {
    name: "",
    just_in_time_provisioning_enabled: false,
    email_verification_required: false,
    auto_approval_on: false,
    require_sso_for_sign_in: false,
    SAML_ENABLED: false,
    SAML_LOGIN_URL: "",
    SAML_CERTIFICATE: "",
    OIDC_ENABLED: false,
    OIDC_PROVIDER_TYPE: "generic",
    OIDC_ISSUER_URL: "",
    OIDC_CLIENT_ID: "",
    OIDC_CLIENT_SECRET_SET: false,
    login_notice_enabled: false,
    login_notice_text: "",
    login_notice_updated_at: null,
    users: [],
    id: null,
    hasChanges: false,
    loading: false,
    dark: typeof document !== "undefined" && document.body.classList.contains("dark-mode"),
  };

  componentDidMount() {
    if (this.props.resources.userEnterpriseLoaded) {
      this.syncEnterpriseSettings(this.props.resources.userEnterprise);
    }
    this.setupDarkModeListener();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.resources.userEnterprise !== this.props.resources.userEnterprise &&
      this.props.resources.userEnterprise
    ) {
      this.syncEnterpriseSettings(this.props.resources.userEnterprise);
    }
  }

  componentWillUnmount() {
    if (this.darkObserver) {
      this.darkObserver.disconnect();
    }
  }

  syncEnterpriseSettings = (enterprise = {}) => {
    this.setState({
      name: enterprise.name || "",
      just_in_time_provisioning_enabled: !!enterprise.just_in_time_provisioning_enabled,
      email_verification_required: !!enterprise.email_verification_required,
      auto_approval_on: !!enterprise.auto_approval_on,
      require_sso_for_sign_in: !!enterprise.require_sso_for_sign_in,
      SAML_ENABLED: !!enterprise.SAML_ENABLED,
      SAML_LOGIN_URL: enterprise.SAML_LOGIN_URL || "",
      SAML_CERTIFICATE: enterprise.SAML_CERTIFICATE || "",
      OIDC_ENABLED: !!enterprise.OIDC_ENABLED,
      OIDC_PROVIDER_TYPE: enterprise.OIDC_PROVIDER_TYPE || "generic",
      OIDC_ISSUER_URL: enterprise.OIDC_ISSUER_URL || "",
      OIDC_CLIENT_ID: enterprise.OIDC_CLIENT_ID || "",
      OIDC_CLIENT_SECRET_SET: !!enterprise.OIDC_CLIENT_SECRET_SET,
      login_notice_enabled: !!enterprise.login_notice_enabled,
      login_notice_text: enterprise.login_notice_text || "",
      login_notice_updated_at: enterprise.login_notice_updated_at || null,
      users:
        enterprise.users ||
        enterprise.enterpriseUsers ||
        enterprise.enterprise_users ||
        [],
      id: enterprise.id || enterprise.enterprise_id || null,
      hasChanges: false,
      loading: false,
    });
  };

  setupDarkModeListener = () => {
    if (typeof document === "undefined" || typeof MutationObserver === "undefined") {
      return;
    }

    const isDark = document.body.classList.contains("dark-mode");
    if (this.state.dark !== isDark) {
      this.setState({ dark: isDark });
    }

    this.darkObserver = new MutationObserver(() => {
      const darkMode = document.body.classList.contains("dark-mode");
      this.setState((prev) => (prev.dark === darkMode ? null : { dark: darkMode }));
    });

    this.darkObserver.observe(document.body, { attributes: true, attributeFilter: ["class"] });
  };

  getThemeStyles = () => getStyles(this.state.dark);

  handleInputFocus = (event) => {
    const dark = this.state.dark;
    event.target.style.borderColor = dark ? "#60a5fa" : "#3b82f6";
    event.target.style.boxShadow = dark
      ? "0 0 0 3px rgba(96,165,250,0.25)"
      : "0 0 0 3px rgba(59,130,246,0.18)";
  };

  handleInputBlur = (event) => {
    const dark = this.state.dark;
    event.target.style.borderColor = dark ? "rgba(148, 163, 184, 0.4)" : "#cbd5f5";
    event.target.style.boxShadow = "none";
  };

  handleFieldChange = (key, value) => {
    this.setState({
      [key]: value,
      hasChanges: true,
    });
  };

  onCancel = () => {
    this.syncEnterpriseSettings(this.props.resources.userEnterprise || {});
  };

  onSave = () => {
    const {
      name,
      just_in_time_provisioning_enabled,
      email_verification_required,
      auto_approval_on,
      require_sso_for_sign_in,
      login_notice_enabled,
      login_notice_text,
      id,
    } = this.state;
    const canManageLoginNotice = Boolean(
      this.props.user?.is_enterprise_admin || this.props.user?.has_admin_privileges,
    );

    if (!id) {
      NotificationManager.alert("Unable to determine the team to update.");
      return;
    }

    this.setState({ loading: true });

    const data = {
      name,
      just_in_time_provisioning_enabled,
      email_verification_required,
      auto_approval_on,
      require_sso_for_sign_in,
    };

    if (canManageLoginNotice) {
      data.login_notice_enabled = login_notice_enabled;
      data.login_notice_text = login_notice_text;
    }

    axios
      .put(`/v1/enterprises/${id}`, data, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => {
        this.syncEnterpriseSettings(res.data.data || {});
        this.props.updateFetchWrapperState({
          resources: {
            ...this.props.resources,
            userEnterprise: res.data.data,
          },
        });
        NotificationManager.success("Team settings updated successfully");
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false });
        NotificationManager.alert("Failed to update team settings");
      });
  };

  renderToggleControl = (config) => {
    const styles = this.getThemeStyles();
    const { label, description, value, onToggle, accent = "#2563eb", disabled = false } = config;
    return (
      <button
        type="button"
        aria-pressed={value}
        onClick={() => {
          if (!disabled) {
            onToggle();
          }
        }}
        disabled={disabled}
        style={{
          ...styles.toggleButton(value, accent),
          ...(disabled ? styles.toggleButtonDisabled : {}),
        }}
      >
        <div style={styles.toggleCopy}>
          <span style={{ ...styles.toggleLabel, color: value ? accent : styles.toggleLabel.color }}>
            {label}
          </span>
          {description ? <p style={styles.toggleDescription}>{description}</p> : null}
        </div>
        <span style={styles.toggleSwitch(value, accent)} aria-hidden="true">
          <span style={styles.toggleKnob(value)} />
        </span>
      </button>
    );
  };

  renderAdminChip = (email, index) => {
    const styles = this.getThemeStyles();
    const initial = email ? email.charAt(0).toUpperCase() : "?";
    return (
      <span key={`${email || "admin"}-${index}`} style={styles.adminChip}>
        <span style={styles.adminInitial}>{initial}</span>
        {email}
      </span>
    );
  };

  render() {
    const {
      name,
      just_in_time_provisioning_enabled,
      email_verification_required,
      auto_approval_on,
      require_sso_for_sign_in,
      SAML_ENABLED,
      SAML_LOGIN_URL,
      SAML_CERTIFICATE,
      OIDC_ENABLED,
      OIDC_PROVIDER_TYPE,
      OIDC_ISSUER_URL,
      OIDC_CLIENT_ID,
      OIDC_CLIENT_SECRET_SET,
      login_notice_enabled,
      login_notice_text,
      login_notice_updated_at,
      users,
      loading,
      hasChanges,
    } = this.state;

    if (this.props.resources.userEnterpriseLoading) {
      return <Loading black />;
    }

    const styles = this.getThemeStyles();

    const disableActions = loading || !hasChanges;
    const canManageLoginNotice = Boolean(
      this.props.user?.is_enterprise_admin || this.props.user?.has_admin_privileges,
    );
    const samlConfigured = Boolean(
      SAML_ENABLED &&
        String(SAML_LOGIN_URL || "").trim() &&
        String(SAML_CERTIFICATE || "").trim(),
    );
    const oidcConfigured = Boolean(
      OIDC_ENABLED &&
        String(OIDC_ISSUER_URL || "").trim() &&
        String(OIDC_CLIENT_ID || "").trim() &&
        OIDC_CLIENT_SECRET_SET,
    );
    const ssoConfigured = samlConfigured || oidcConfigured;
    const configuredProviders = [
      samlConfigured ? "SAML" : null,
      oidcConfigured
        ? `OIDC${OIDC_PROVIDER_TYPE && OIDC_PROVIDER_TYPE !== "generic" ? ` (${OIDC_PROVIDER_TYPE})` : ""}`
        : null,
    ].filter(Boolean);
    const requireSsoToggleDisabled = !require_sso_for_sign_in && !ssoConfigured;
    const enterpriseAdmins = (users || [])
      .filter((user) => user && (user.is_enterprise_admin || user.is_enterprise_adm))
      .map((user) => user.email_id || user.email || "");

    const headerMeta = [
      { label: "Team name", value: name || "Not set" },
      {
        label: "Provisioning",
        value: just_in_time_provisioning_enabled ? "Just-in-time on" : "Manual invites",
      },
      {
        label: "Email verification",
        value: email_verification_required ? "Required" : "Optional",
      },
      {
        label: "Password sign-in",
        value: require_sso_for_sign_in ? "SSO required" : "Allowed",
      },
      {
        label: "SSO providers",
        value: configuredProviders.length ? configuredProviders.join(", ") : "Not configured",
      },
      {
        label: "Admins",
        value: enterpriseAdmins.length ? `${enterpriseAdmins.length} assigned` : "Add contacts",
      },
    ];

    return (
      <div style={styles.pageWrapper}>
        <section style={styles.headerCard}>
          <div style={styles.headerLead}>
            <div style={styles.titleBlock}>
              <h2 style={styles.title}>Team settings</h2>
              <p style={styles.subtitle}>
                Manage the default identity and access rules that apply when users join this team.
              </p>
            </div>
            <div style={styles.headerActions}>
              <button
                type="button"
                className="button secondary"
                style={{
                  ...styles.actionButton,
                  ...styles.secondaryButton,
                  ...(disableActions ? styles.disabledButton : {}),
                }}
                onClick={this.onCancel}
                disabled={disableActions}
              >
                Cancel
              </button>
              <button
                type="button"
                className="button"
                style={{
                  ...styles.actionButton,
                  ...styles.primaryButton,
                  ...(disableActions ? styles.disabledButton : {}),
                }}
                onClick={this.onSave}
                disabled={disableActions}
              >
                {loading ? "Saving…" : "Save changes"}
              </button>
            </div>
          </div>
          <div style={styles.headerMetaRow}>
            {headerMeta.map((item) => (
              <div key={item.label} style={styles.metaItem}>
                <span style={styles.metaLabel}>{item.label}</span>
                <span style={styles.metaValue}>{item.value}</span>
              </div>
            ))}
          </div>
          <p style={styles.headerNote}>
            Changes here affect invitations, approvals, and how new sign-ins are handled across the team.
          </p>
        </section>

        <div style={styles.sectionGrid}>
          <section style={styles.sectionCard}>
            <div style={styles.sectionHeading}>
              <h3 style={styles.sectionTitle}>Organization identity</h3>
              <p style={styles.sectionDescription}>
                Keep the team name consistent anywhere users interact with this workspace.
              </p>
            </div>
            <div style={styles.fieldStack}>
              <div style={styles.field}>
                <label htmlFor="team-name-input" style={styles.fieldLabel}>
                  Team name
                </label>
                <p style={styles.fieldHint}>
                  Appears in billing summaries, approval flows, and the SSO sign-in handoff.
                </p>
              </div>
              <input
                id="team-name-input"
                type="text"
                value={name}
                onChange={(event) => this.handleFieldChange("name", event.target.value)}
                onFocus={this.handleInputFocus}
                onBlur={this.handleInputBlur}
                placeholder="Acme Robotics"
                style={styles.input}
              />
              <p style={styles.helperText}>Use up to 60 characters.</p>
            </div>
          </section>

          <section style={styles.sectionCard}>
            <div style={styles.sectionHeading}>
              <h3 style={styles.sectionTitle}>Access defaults</h3>
              <p style={styles.sectionDescription}>
                Define what happens when someone signs in with Synaccess credentials or enterprise SSO.
              </p>
            </div>
            <div style={styles.toggleList}>
              {this.renderToggleControl({
                label: "Require SSO for sign-in",
                description: requireSsoToggleDisabled
                  ? "Available after SAML or OIDC is enabled with its required connection details."
                  : "Block web password sign-in and password reset/setup flows for this team.",
                value: require_sso_for_sign_in,
                onToggle: () =>
                  this.handleFieldChange("require_sso_for_sign_in", !require_sso_for_sign_in),
                accent: "#0f766e",
                disabled: requireSsoToggleDisabled,
              })}
              {this.renderToggleControl({
                label: "Require email verification",
                description: "Confirm email ownership before the first login completes.",
                value: email_verification_required,
                onToggle: () =>
                  this.handleFieldChange("email_verification_required", !email_verification_required),
                accent: "var(--highlight-color)",
              })}
              {this.renderToggleControl({
                label: "Just-in-time provisioning",
                description: "Create the user record as soon as authentication succeeds.",
                value: just_in_time_provisioning_enabled,
                onToggle: () =>
                  this.handleFieldChange("just_in_time_provisioning_enabled", !just_in_time_provisioning_enabled),
                accent: "var(--secondary-color)",
              })}
              {this.renderToggleControl({
                label: "Auto-approve JIT users",
                description: "Grant device access without manual review for SSO-created accounts.",
                value: auto_approval_on,
                onToggle: () => this.handleFieldChange("auto_approval_on", !auto_approval_on),
                accent: "var(--quaternary-color)",
              })}
            </div>
            <p style={styles.helperText}>
              Pair these choices with your identity provider policies so the first sign-in is predictable and reviewable.
            </p>
          </section>

          <section style={styles.sectionCard}>
            <div style={styles.sectionHeading}>
              <h3 style={styles.sectionTitle}>Enterprise administrators</h3>
              <p style={styles.sectionDescription}>
                These contacts are responsible for billing and access escalations.
              </p>
            </div>
            {enterpriseAdmins.length > 0 ? (
              <div style={styles.adminList}>
                {enterpriseAdmins.map((email, index) => this.renderAdminChip(email, index))}
              </div>
            ) : (
              <div style={styles.emptyState}>
                Add at least one administrator so approvals never bottleneck.
              </div>
            )}
          </section>

          {canManageLoginNotice ? (
            <section style={styles.sectionCard}>
              <div style={styles.sectionHeading}>
                <h3 style={styles.sectionTitle}>Login notice</h3>
                <p style={styles.sectionDescription}>
                  Show a system use notice after users sign in to this enterprise.
                </p>
              </div>
              <div style={styles.toggleList}>
                {this.renderToggleControl({
                  label: "Enable login notice",
                  description: "Display this notice until each user acknowledges the current version.",
                  value: login_notice_enabled,
                  onToggle: () =>
                    this.handleFieldChange("login_notice_enabled", !login_notice_enabled),
                  accent: "var(--highlight-color)",
                })}
              </div>
              <div style={styles.fieldStack}>
                <div style={styles.field}>
                  <label htmlFor="login-notice-text" style={styles.fieldLabel}>
                    Notice text
                  </label>
                  <p style={styles.fieldHint}>
                    Plain text only. Line breaks and spacing are preserved.
                  </p>
                </div>
                <textarea
                  id="login-notice-text"
                  value={login_notice_text}
                  onChange={(event) =>
                    this.handleFieldChange("login_notice_text", event.target.value)
                  }
                  onFocus={this.handleInputFocus}
                  onBlur={this.handleInputBlur}
                  placeholder="WARNING:"
                  style={{
                    ...styles.input,
                    ...styles.textarea,
                  }}
                />
                <p style={styles.helperText}>
                  {login_notice_updated_at
                    ? `Last updated ${new Date(login_notice_updated_at).toLocaleString()}`
                    : "No login notice version has been saved yet."}
                </p>
              </div>
            </section>
          ) : null}
        </div>
      </div>
    );
  }
}
